//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/UserDefinedObjects.js";
import "../no/TransientObject.js";
let d=[[[0,"EventReason",0,0],[0,"UserDefinedObject",0,"UserDefinedObjects.UserDefinedObject",0]],[[[],"Dispose",{},0,0]],[]];
SPLM.UserDefinedObjects.UserDefinedEvent = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.UserDefinedObjects.UserDefinedEvent";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.UserDefinedObjects.UserDefinedEvent.Reason = Object.freeze({
    "Display" : "Display", "Delete" : "Delete", "Update" : "Update", "Selection" : "Selection", "Fit" : "Fit", "AttentionPoint" : "AttentionPoint", "Info" : "Info", "Edit" : "Edit", "Suppress" : "Suppress", "ScreenSizeFit" : "ScreenSizeFit", "PreSave" : "PreSave", "PostLoad" : "PostLoad", "OnDelete" : "OnDelete"});

export default SPLM;